<script setup lang="ts">
const props = defineProps<{
  url?: string
  title?: string
  description?: string
  modalClasses?: string
  bodyClasses?: string
  headerClasses?: string
  footerClasses?: string
  inputWrapperClasses?: string
  copyButtonClasses?: string
  socialShareButtonClasses?: string
}>()

const emit = defineEmits(['close'])
</script>

<template>
  <Modal
    :modal-classes="props.modalClasses"
    :body-classes="'tw-pb-8 tw-px-6 ' + (props.bodyClasses ?? '')"
    :header-classes="props.headerClasses"
    :footer-classes="props.footerClasses"
    @close="() => emit('close')"
  >
    <template #header>
      {{ $t('Share') }}
    </template>

    <template #body>
      <Share
        :title="props.title"
        :description="props.description"
        :url="url"
        :input-wrapper-classes="props.inputWrapperClasses"
        :copy-button-classes="props.copyButtonClasses"
        :social-share-button-classes="props.socialShareButtonClasses"
      />
    </template>
  </Modal>
</template>
